import css from './index.module.css';

import SEO from "@components/seo";
import CartProduct from "@components/cartProduct";
import useUserData from "@hooks/useUserData";
import EmptyCart from "@pages/system/emptyCart";
import MainContent from "@components/content";
import { Link, useNavigate } from 'react-router-dom';

export default function Cart() {
  const { cartData } = useUserData();
  const navigate = useNavigate();
  
  const totalPrice = Array.isArray(cartData)
    ? cartData.reduce((acc, cart) => acc + cart.product.price * Number(cart.count), 0)
    : 0;

  return (
  <>
    {(!cartData || cartData.length <= 0) ? 
      <EmptyCart /> :
    
    <MainContent header="Корзина">    
      <SEO 
        title={`Корзина`}
        description={`Корзина`}
        ogImage={``}
        ogUrl={``}
      />

      <div className={css.cart}>
        <Link to={`/webapp`} className={css.back}>Добавить больше товаров</Link>

        <div className={css.productList}>
          {cartData && cartData.map(cart => (
            <CartProduct 
              id={cart.id}
              prodID={cart.product.id}
              image={cart.product.images[0]}
              title={cart.product.name}
              price={cart.product.price}
              unit={cart.product.unit}
              quantity={cart.product.quantity}
              unitCart={cart.unit}
              count={cart.count}
              buttons={true}
            />
          ))}
        </div>

        <div className={css.cartInfo}>
          <div className={css.total}>
            <div className={`${css.item}`}>
              <a>Итоговая стоимость:</a>
              <b>{totalPrice.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽</b>
            </div>

            <button className={css.checkout} onClick={() => navigate('/webapp/checkout')}>Перейти к оформлению</button>
          </div>
        </div>
      </div>
    </MainContent>
    }
    </>
  )
}